(function () {
  var bar = document.querySelector('[data-sova-sticky-atc]');
  var mainAtc = document.querySelector('[data-sova-atc]');
  var form = document.getElementById('sova-product-form');
  if (!bar || !mainAtc) return;

  bar.hidden = false;

  var btn = bar.querySelector('[data-sova-sticky-atc-btn]');
  if (btn && form) {
    btn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }

  /* Keep sticky label in sync with the main button's live total */
  var mainTotal = document.querySelector('[data-sova-atc-total]');
  var stickyPrice = bar.querySelector('.sova-sticky-atc-price');
  if (mainTotal && stickyPrice && 'MutationObserver' in window) {
    new MutationObserver(function () {
      stickyPrice.textContent = mainTotal.textContent;
    }).observe(mainTotal, { childList: true, characterData: true, subtree: true });
  }
})();
